import { UnitSystem } from '../types/event';

const metersToFeet = (m: number) => m * 3.280839895;
const kmhToMph = (kmh: number) => kmh * 0.621371192;
const kmToMiles = (km: number) => km * 0.621371192;

export { metersToFeet };

export const formatAltitude = (altitudeMeters: number, unitSystem: UnitSystem): string => {
  if (unitSystem === 'imperial') return `${Math.round(metersToFeet(altitudeMeters))} ft`;
  return `${Math.round(altitudeMeters)} m`;
};

export const formatSpeed = (speedKmh: number, unitSystem: UnitSystem): string => {
  if (unitSystem === 'imperial') return `${kmhToMph(speedKmh).toFixed(1)} mph`;
  return `${speedKmh.toFixed(1)} km/h`;
};

export const formatVerticalSpeed = (verticalSpeedMps: number, unitSystem: UnitSystem): string => {
  if (unitSystem === 'imperial') {
    const ftPerMin = verticalSpeedMps * 196.850394;
    return `${ftPerMin.toFixed(0)} ft/min`;
  }
  return `${verticalSpeedMps.toFixed(1)} m/s`;
};

export const formatDistanceKm = (distanceKm: number, unitSystem: UnitSystem): string => {
  if (unitSystem === 'imperial') return `${kmToMiles(distanceKm).toFixed(2)} mi`;
  return `${distanceKm.toFixed(2)} km`;
};

export const heartRateToSignalLevel = (avgHeartRateBpm: number): number => {
  if (avgHeartRateBpm < 110) return 1;
  if (avgHeartRateBpm < 130) return 2;
  if (avgHeartRateBpm < 150) return 3;
  if (avgHeartRateBpm < 170) return 4;
  return 5;
};

const HIGH_STRESS = 5;
const MID_STRESS = 3;

export const stressClassFor = (stress: number): string =>
  stress >= HIGH_STRESS ? 'hi' : stress >= MID_STRESS ? 'mid' : 'ok';

export const headingToCompass = (deg: number): string => {
  if (!Number.isFinite(deg)) return '';
  const dirs = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'];
  const idx = Math.round(deg / 45) % 8;
  return dirs[idx] || '';
};
